// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__QOVfr","header":"styles_header__bWS8m","text_wrapper":"styles_text_wrapper__ow5mJ","content":"styles_content__OInDS"};